import { render, staticRenderFns } from "./Indexold.vue?vue&type=template&id=0fac9473&"
import script from "./Indexold.vue?vue&type=script&lang=js&"
export * from "./Indexold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports